"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var React = require("react");
var styles_1 = require("./styles/styles");
var padding = 15;
var LineFlyout = /** @class */ (function (_super) {
    __extends(LineFlyout, _super);
    function LineFlyout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineFlyout.prototype.render = function () {
        var _a = this.props, x = _a.x, datum = _a.datum, height = _a.height;
        // TODO TFS 960371 add localization support to formatting dates
        // and to dynamically determine the proper date format for the
        // underlying data
        var date = moment(datum.timestamp).format('M/D/YYYY');
        return (React.createElement("g", null,
            React.createElement("text", { style: styles_1.dateStyle, x: x - 25, y: 10, fill: styles_1.MetricBlue }, date),
            React.createElement("line", { x1: x, y1: padding, x2: x, y2: height - padding, stroke: 'grey', strokeDasharray: '2' })));
    };
    return LineFlyout;
}(React.PureComponent));
exports.LineFlyout = LineFlyout;
//# sourceMappingURL=LineFlyout.js.map